<script setup lang="ts">
import { useSnackbarStore } from '@/store/snackbar'

interface IProps {
  modelValue?: boolean,
  changeRequestId?: number | string | undefined,
}

const props = withDefaults(defineProps<IProps>(), {
  modelValue: false,
  changeRequestId: undefined,
})

interface Emit {
  (e: 'update:modelValue', value: boolean): void
  (e: 'onClose'): void
}

const emit = defineEmits<Emit>()

const route = useRoute()

const snackbarStore = useSnackbarStore()

const loading = ref<boolean>(false)

const hideDialog = () => {
  emit('update:modelValue', false)
  onClose()
}

const onClose = async () => {
  emit('onClose')
}

watch(() => props.modelValue, () => {
  // on show Dialog
  if (!!props.modelValue) {
  }
  // on hide Dialog
  else {
    onClose()
  }
})
</script>

<template>
  <VDialog
    :model-value="modelValue"
    max-width="800"
    :persistent="!!loading"
    @after-leave="onClose"
    @update:modelValue="emit('update:modelValue')"
  >
    <VBtn
      variant="elevated"
      density="compact"
      icon="tabler-x"
      :disabled="!!loading"
      class="v-dialog-close-btn"
      @click="hideDialog"
    />

    <ChangeRequestBlock
      :change-request-id="changeRequestId ? String(changeRequestId) : null"
      :action-required-filter="false"
      :show-change-request-external-link="true"
    />
  </VDialog>
</template>
